import { FormTitle, NavigationButtons } from '@molecules/*';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';

export const ReportToStreetLightsTeam = () => {
  const title =
    'Report an issue with a sign or bollard with a light to the Street Lights team';

  const FMS_STREET_LIGHTS_REPORT =
    'https://mywestminster.westminster.gov.uk/report-it/street-lights';

  const navigate = useNavigate();

  const handleButtonPrevious = {
    onClick: () => {
      navigate(RoutesList.ISSUE_TYPE);
    },
  };
  const handleButtonNext = {
    label: 'Report a street lights issue',
    onClick: () => {
      window.location.replace(FMS_STREET_LIGHTS_REPORT);
    },
  };

  return (
    <>
      <FormTitle text={title} />
      <div className="text-text-body text-bodyLg my-4 flex flex-col gap-4 font-normal">
        <p>We'll send you to the street lights form.</p>
        <br />
        <p>To help with the report we need to know:</p>
        <ul className="ml-6 list-disc">
          <li className="ml-6">details of the issue</li>
          <li className="ml-6">the location of the issue</li>
        </ul>

        <p>It's useful to provide:</p>
        <ul className="ml-6 list-disc">
          <li className="ml-6">photos of the issue</li>
          <li className="ml-6">your contact details</li>
        </ul>

        <p>Use the button below to start your report.</p>
      </div>
      <section data-testid="navigate-to-homepage" className="mt-20">
        <NavigationButtons
          buttonNext={handleButtonNext}
          buttonPrevious={handleButtonPrevious}
        />
      </section>
    </>
  );
};
